// Base stylesheet needed for every page
import './scss/app.scss';

require('./scripts/header');
//require('./scripts/backInStock');
require('./scripts/backInStockNew');
require('./scripts/cart');
require('./scripts/microcart');
require('./scripts/navigation');
require('./scripts/slider');
require('./scripts/scroll-swiper');
require('./scripts/accordion');
require('./scripts/filters');
require('./scripts/product');
require('./scripts/product-images');
require('./scripts/product-block');
require('./scripts/search');
require('./scripts/size-table');
require('./scripts/product-variants');
require('./scripts/ProductReviews');
require('./scripts/product-recommendations');
require('./scripts/shopReviews');
require('./scripts/quickProductForm');
require('./scripts/localizationForm');
require('./scripts/quantityInput');
require('./scripts/newsletter');
require('./scripts/content-toggler');
